import React from 'react'
import {Text} from '@chakra-ui/react'
import {useSetTimer} from '_customHooks'

interface TimerProps {
    time: string
    textStyle?: string
    fontSize?: string
    lineHeight?: string
    className?: string
    compact?: boolean
}

const Timer = ({time, textStyle = 'displaySm', compact = false, ...props}: TimerProps) => {
    const timer = useSetTimer(time)
    const displayTimer = compact ? timer.replace(/\s*:\s*/g, ':') : timer

    return (
        <Text textStyle={textStyle} {...props} data-testid="timer">
            {displayTimer}
        </Text>
    )
}
export {Timer}
